import { render, staticRenderFns } from "./TwoFAGoogleAuth.vue?vue&type=template&id=65f210bb&scoped=true"
import script from "./TwoFAGoogleAuth.vue?vue&type=script&lang=js"
export * from "./TwoFAGoogleAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f210bb",
  null
  
)

export default component.exports